"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactFeatures = ContactFeatures;
var React = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _ContactFeaturesContext = require("./internal/ContactFeaturesContext");
var styles = _interopRequireWildcard(require("./styles.module.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Компонент списка отличительных признаков
 * Если элемент не вещается, то он пропадает
 *
 * Адаптивный
 */
function ContactFeatures(_ref) {
  let {
    features
  } = _ref;
  const {
    background
  } = (0, _ContactFeaturesContext.useContactFeaturesContext)();
  return /*#__PURE__*/React.createElement("dl", {
    className: (0, _clsx.default)(styles['features'], styles[`bg_` + background])
  }, features.map((_ref2, i) => {
    let {
      title,
      value
    } = _ref2;
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: styles['item']
    }, /*#__PURE__*/React.createElement("dt", null, title), /*#__PURE__*/React.createElement("dd", null, value));
  }));
}